"use client";

import { useActionState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { login } from "./actions";

// Vizuálne mirror dev/app/login/LoginForm.tsx (rounded-full, sky-400 border).
// Rozdiely od dev:
//   - Po úspešnom login klientsky redirect na "/" (dev nechával form visieť)
//   - Viditeľná chybová správa (dev to mal zakomentované)
//   - Vyhodené checkIpStatus volanie po neúspešnom login (PHP endpoint zatiaľ chýba)
export default function LoginForm() {
  const router = useRouter();

  // useActionState - Next 15+ pattern pre form akcie s loading/error state.
  // Initial state: nie je success, žiadna message.
  const [state, formAction, isPending] = useActionState(login, {
    success: false,
    message: "",
  });

  // Po úspešnom login presunieme používateľa na home.
  // router.push namiesto redirect() v Server Action - chceme aby formulár
  // dostal úspešný state, prešiel cez useActionState a UI vedelo zareagovať.
  useEffect(() => {
    if (state.success) {
      router.push("/");
    }
  }, [state.success, router]);

  return (
    <form action={formAction} className="flex flex-col gap-4 w-full max-w-64">
      <Input
        type="text"
        id="username"
        name="username"
        placeholder="Meno"
        required
        disabled={isPending}
        autoComplete="username"
        className="w-full pr-8 rounded-full placeholder:text-gray-500 border-sky-400 text-xl"
      />

      <Input
        type="password"
        id="password"
        name="password"
        placeholder="Heslo"
        required
        disabled={isPending}
        autoComplete="current-password"
        className="w-full pr-8 rounded-full placeholder:text-gray-500 border-sky-400 text-xl"
      />

      {/* Chybová správa - viditeľná len pri zlyhanom pokuse, nie pri úvodnom render-e */}
      {!state.success && state.message && (
        <p className="text-red-600 text-sm text-center">{state.message}</p>
      )}

      <Button
        type="submit"
        variant="outline"
        disabled={isPending}
        className="w-full text-sky-700 border-sky-400 transition-all duration-200 hover:bg-sky-200 hover:text-sky-700 rounded-full flex items-center justify-center"
      >
        {isPending ? (
          <Loader2 className="animate-spin w-5 h-5" />
        ) : (
          "Prihlásiť"
        )}
      </Button>
    </form>
  );
}
